import React, { useState, useEffect } from "react";
import RoldanDashboard from "./clientTypes/roldan/RoldanDashboard";
import { isMobileDevice } from "../../../utils/deviceDetection";

function ClientTypeTaktik({ mantisBusiness, token, userId, user }) {
  // Extract mantisBusinessId and clientType from props
  const mantisBusinessId = mantisBusiness?._id;
  const clientType = mantisBusiness?.clientType;
  const [isMobileDeviceType, setIsMobileDeviceType] = useState(false);

  // Detect device type (not screen size)
  useEffect(() => {
    setIsMobileDeviceType(isMobileDevice());
  }, []);

  // Debug logging
  console.log("ClientTypeTaktik received mantisBusiness:", mantisBusiness);
  console.log("Extracted mantisBusinessId:", mantisBusinessId);
  console.log("Extracted clientType:", clientType);

  const renderClientInterface = () => {
    switch (clientType) {
      case "ROLDAN":
        return (
          <RoldanDashboard
            mantisBusinessId={mantisBusinessId}
            token={token}
            userId={userId}
            user={user}
          />
        );
      case "LOGISTICS_DEMO":
        return (
          <RoldanDashboard
            mantisBusinessId={mantisBusinessId}
            token={token}
            userId={userId}
            user={user}
            isLogisticsDemo
          />
        );
      default:
        return (
          <div style={{ padding: "1rem" }}>
            <h2 style={{ margin: 0 }}>Client Type Taktik</h2>
            <p>
              No interface available for client type: {clientType || "Unknown"}
            </p>
          </div>
        );
    }
  };

  // Show loading or error state if mantisBusiness is not provided
  if (!mantisBusiness) {
    return (
      <div style={{ padding: "1rem" }}>
        <h2 style={{ margin: 0 }}>Client Type Taktik</h2>
        <p>No mantis business data provided.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: isMobileDeviceType ? "0" : "1rem" }}>
      {renderClientInterface()}
    </div>
  );
}

export default ClientTypeTaktik;


